import type {MRT_ColumnDef} from 'mantine-react-table';
import {useMemo} from 'react';
import type {
  SafetyEventSimpleResponse,
  SafetyEventStateEnum,
} from 'src/api/ProactApiClient';
import {Pill} from 'src/design/atoms/Pill';
import {SafetyEventStatePill} from 'src/shared/constants/PillConstants';
import {SafetyEventDataOptions} from 'src/shared/constants/columnFilterData';

export const useSafetyEventColumns = () => {
  const columns = useMemo<MRT_ColumnDef<SafetyEventSimpleResponse>[]>(
    () => [
      {
        accessorKey: 'shortDescription',
        header: 'Event Description',
      },
      {
        accessorKey: 'jobDescription',
        header: 'Job Description',
      },
      {
        accessorKey: 'internalIdentifier',
        header: 'Identifier',
      },
      {
        accessorKey: 'projectName',
        header: 'Project',
        enableSorting: false,
        enableColumnFilter: false,
      },
      {
        accessorKey: 'creator.name',
        header: 'Created By',
      },
      {
        accessorKey: 'safetyReviewer.name',
        header: 'Reviewed By',
      },
      {
        accessorKey: 'state',
        header: 'State',
        enableColumnFilterModes: false,
        filterVariant: 'multi-select',
        mantineFilterSelectProps: {
          data: SafetyEventDataOptions,
        },
        Cell: ({cell}) => {
          const cellValue = cell.getValue<SafetyEventStateEnum>();
          const pillConfig = SafetyEventStatePill(cellValue);
          return <Pill text={pillConfig.text} color={pillConfig.color} />;
        },
      },
    ],
    []
  );

  return columns;
};
